import baseUrl from '@pocapan/shared/utils/baseUrl';
import getToken from '@pocapan/shared/utils/getToken';

export default async function AddTradingPhotoCardsV2(userProfileId, tradingPhotoCards, dataUrls) {
  return fetch(`${baseUrl()}/api/v2/trading_photo_cards/`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    body: JSON.stringify({
      data_urls: dataUrls,
      trading_photo_cards: tradingPhotoCards.map((t) => {
        return {
          artist_id: t.artistId,
          member_id: t.photoCard.memberId,
          user_profile_id: userProfileId,
          photo_card_id: t.photoCard.photoCardId,
          quantity: 1,
          category: t.category || 'sale',
          price: t.price,
          description: t.description,
          trade_method: t.tradeMethod,
          is_new_item: t.isNewItem
        };
      })
    })
  });
}
